import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './reminder-app/index.css';
import App from './reminder-app/App';
import * as serviceWorker from './reminder-app/serviceWorker';
import Cookies from 'universal-cookie';
import areIntlLocalesSupported from 'intl-locales-supported'
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import { flattenMessages } from './reminder-app/utils/i18n';
import messages from './reminder-app/i18n/messages';
import './assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/css/form-pages.css';

addLocaleData(en);
addLocaleData(es);

const localesMyAppSupports = [
    'en', 'es'
];

if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported(localesMyAppSupports)) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and replace the constructors with need with the polyfill's.
        let IntlPolyfill = require('intl');
        Intl.NumberFormat   = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
} else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = require('intl');
}

const cookies = new Cookies();
let locale = (cookies && cookies.get('lang'))
              || (navigator.languages && navigator.languages[0])
              || (navigator.language)
              || (navigator.userLanguage)
              || 'en';

locale = (localesMyAppSupports.indexOf(locale) > -1) ? locale : 'en';

ReactDOM.render(
  <IntlProvider locale={locale} key={locale} messages={flattenMessages(messages[locale])}>
    <App />
  </IntlProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
